// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Drawer$Showside from "../components/Drawer.bs.js";
import * as Navbar$Showside from "../components/Navbar.bs.js";
import * as SidePanel$Showside from "../components/SidePanel.bs.js";
import * as UseAnchors$Showside from "../hook/UseAnchors.bs.js";
import * as DrawerState$Showside from "../context/DrawerState.bs.js";
import * as UseTracking$Showside from "../hook/UseTracking.bs.js";
import * as HideOnScroll$Showside from "../utils/HideOnScroll.bs.js";
import * as BaseWithTheme$Showside from "../context/BaseWithTheme.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as UseContextualL1s$Showside from "../hook/UseContextualL1s.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as PausePageScrolling$Showside from "../components/PausePageScrolling.bs.js";
import * as EntrypointCallbacks$Showside from "../EntrypointCallbacks.bs.js";
import * as EscapeKeyController$Showside from "../components/EscapeKeyController.bs.js";
import * as MiniCartDrawer_Lazy$Showside from "../components/MiniCartDrawer_Lazy.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as QuickViewOverlay_Lazy$Showside from "../pages/QuickViewOverlay_Lazy.bs.js";
import * as PictureInPicture2_Lazy$Showside from "../utils/PictureInPicture2_Lazy.bs.js";
import * as GridDensityZoomProvider$Showside from "../context/GridDensityZoomProvider.bs.js";
import * as ListPageWithLazyContent$Showside from "../pages/ListPageWithLazyContent.bs.js";
import * as PictureInPictureContext$Showside from "../utils/PictureInPictureContext.bs.js";
import * as ProductDetailsPage_Lazy$Showside from "../pages/ProductDetailsPage_Lazy.bs.js";
import * as ListPageLayoutController$Showside from "../hook/ListPageLayoutController.bs.js";
function BottombarApp(Props) {
  var attributes = Props.attributes;
  var embedType = Props.embedType;
  var enabled = Props.enabled;
  var match = React.useState(function () {
    return true;
  });
  var setShouldDrawerShowShadow = match[1];
  var shouldDrawerShowShadow = match[0];
  var drawerContentRef = React.useRef(null);
  var scrollableContainerRef = React.useRef(null);
  var entrypointRef = React.useRef(null);
  var match$1 = ViewportContext$Showside.use(undefined);
  var breakpoint = match$1.breakpoint;
  var isMobile = match$1.isMobile;
  var match$2 = ConfigurationProvider$Showside.use(undefined);
  var config = match$2.config;
  var match$3 = DrawerState$Showside.use(undefined);
  var onCloseDrawer = match$3.onClose;
  var onOpenDrawer = match$3.onOpen;
  var onOpeningDrawer = match$3.onOpening;
  var drawerStateRef = match$3.stateRef;
  var drawerState = match$3.state;
  var match$4 = RouterProvider$Showside.useRouter(undefined);
  var isQuickView = match$4.isQuickView;
  var reset = match$4.reset;
  var quickViewUnderlyingRoute = match$4.quickViewUnderlyingRoute;
  var route = match$4.route;
  var enabled$1 = enabled || route !== /* NotRendered */0;
  var contextualRoot = UseContextualL1s$Showside.useContextualRoot(drawerState, embedType, window.location.pathname);
  var match$5 = React.useState(function () {
    return false;
  });
  var setScrollLocked = match$5[1];
  var scrollLocked = match$5[0];
  var scrollLockedRef = React.useRef(false);
  var trackEvent = UseTracking$Showside.use(embedType);
  React.useEffect(function () {
    if (route !== /* NotRendered */0 && !isQuickView && drawerState !== /* Opening */1) {
      Curry._1(onOpenDrawer, undefined);
    } else if (route === /* NotRendered */0) {
      Curry._1(onCloseDrawer, undefined);
    }
  }, [route, drawerState]);
  var anchorHookResult = UseAnchors$Showside.useAnchors(undefined, undefined);
  var handleDrawerStateChange = React.useCallback(function (isOpen) {
    if (isOpen) {
      return Curry._1(onOpenDrawer, undefined);
    } else {
      Curry._1(onCloseDrawer, undefined);
      return Curry._1(reset, undefined);
    }
  }, [reset]);
  var handleScrollLock = function (lock) {
    Curry._1(setScrollLocked, function (param) {
      return lock;
    });
    scrollLockedRef.current = lock;
  };
  var handleMenuVisibilityChange = React.useCallback(function (isVisible) {
    Curry._1(setShouldDrawerShowShadow, function (param) {
      return !isVisible;
    });
  }, []);
  var renderMainWrapper = function (children) {
    if (config.settings.smartbarEnabled) {
      return React.createElement(HideOnScroll$Showside.make, {
        enabled: drawerState === /* Closed */0 && config.settings.autoHideBottombar && isMobile,
        children: React.createElement(Drawer$Showside.make, {
          children: children,
          isOpen: drawerState === /* Open */2,
          scrollRef: scrollableContainerRef,
          onChangeState: handleDrawerStateChange,
          showDragIndicator: isMobile,
          showShadow: shouldDrawerShowShadow,
          fwdRef: ReactDOMUtils$Showside.Ref.domRef(entrypointRef),
          onScrollLock: handleScrollLock
        })
      });
    } else {
      return React.createElement(SidePanel$Showside.make, {
        children: children,
        isOpen: drawerState === /* Open */2,
        fwdRef: ReactDOMUtils$Showside.Ref.domRef(entrypointRef)
      });
    }
  };
  var openEventTriggered = React.useRef(false);
  React.useEffect(function () {
    var match = openEventTriggered.current;
    switch (drawerState) {
      case /* Closed */0:
        openEventTriggered.current = false;
        break;
      case /* Opening */1:
        break;
      case /* Open */2:
        if (match) {} else {
          Curry.app(trackEvent, ["open", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
          openEventTriggered.current = true;
        }
        break;
    }
  }, [drawerState, RouterProvider$Showside.toString(route)]);
  var isPausingPageScroll = PausePageScrolling$Showside.useIsPausing(undefined);
  React.useEffect(function () {
    var handleTouchMove = function (e) {
      if (isPausingPageScroll && drawerStateRef.current === /* Opening */1) {
        e.preventDefault();
        return;
      }
    };
    var addEventListener = function (param) {
      window.addEventListener("touchmove", handleTouchMove, {
        capture: false,
        once: false,
        passive: false
      });
    };
    var removeEventListener = function (param) {
      window.removeEventListener("touchmove", handleTouchMove, {
        capture: false,
        passive: false
      });
    };
    addEventListener(undefined);
    return removeEventListener;
  }, [isPausingPageScroll]);
  var renderContent = function (param) {
    if (!enabled$1) {
      return null;
    }
    var tmp = {
      config: config,
      embedType: embedType,
      onOpeningDrawer: onOpeningDrawer,
      children: null
    };
    if (attributes !== undefined) {
      tmp.attributes = Caml_option.valFromOption(attributes);
    }
    if (contextualRoot !== undefined) {
      tmp.contextualRoot = Caml_option.valFromOption(contextualRoot);
    }
    var tmp$1;
    var exit = 0;
    var exit$1 = 0;
    var exit$2 = 0;
    if (quickViewUnderlyingRoute !== undefined && !(typeof quickViewUnderlyingRoute === "number" || quickViewUnderlyingRoute.TAG !== /* PDP */2)) {
      exit = 1;
    } else {
      exit$2 = 4;
    }
    if (exit$2 === 4) {
      if (typeof route === "number" || route.TAG !== /* PDP */2) {
        exit$1 = 3;
      } else {
        exit = 1;
      }
    }
    if (exit$1 === 3) {
      if (quickViewUnderlyingRoute !== undefined && typeof quickViewUnderlyingRoute !== "number") {
        switch (quickViewUnderlyingRoute.TAG | 0) {
          case /* Home */0:
          case /* ListPage */1:
          case /* QuickView */3:
            exit = 2;
            break;
        }
      } else {
        exit = 2;
      }
    }
    switch (exit) {
      case 1:
        tmp$1 = React.createElement(ProductDetailsPage_Lazy$Showside.make, {
          viewport: entrypointRef,
          scrollableContainerRef: scrollableContainerRef,
          shouldForceMobile: (config.settings.panelSize === /* Small */2 || config.settings.panelSize === /* Medium */1 && breakpoint <= /* Lg */3) && !config.settings.smartbarEnabled
        });
        break;
      case 2:
        var tmp$2;
        var exit$3 = 0;
        var exit$4 = 0;
        if (quickViewUnderlyingRoute !== undefined) {
          if (typeof quickViewUnderlyingRoute === "number") {
            exit$3 = 3;
          } else {
            switch (quickViewUnderlyingRoute.TAG | 0) {
              case /* PDP */2:
              case /* QuickView */3:
                exit$4 = 4;
                break;
              default:
                exit$3 = 3;
            }
          }
        } else {
          exit$4 = 4;
        }
        if (exit$4 === 4) {
          if (typeof route === "number") {
            exit$3 = 3;
          } else {
            switch (route.TAG | 0) {
              case /* PDP */2:
              case /* QuickView */3:
                tmp$2 = null;
                break;
              default:
                exit$3 = 3;
            }
          }
        }
        if (exit$3 === 3) {
          tmp$2 = React.createElement(Navbar$Showside.make, {
            drawerState: drawerState,
            embedType: embedType,
            onHoverMenuVisibilityChanged: handleMenuVisibilityChange
          });
        }
        tmp$1 = React.createElement(ListPageWithLazyContent$Showside.make, {
          scrollableContainerRef: scrollableContainerRef,
          drawerState: drawerState,
          anchorHookResult: anchorHookResult,
          children: tmp$2
        });
        break;
    }
    var tmp$3;
    tmp$3 = typeof route === "number" || route.TAG !== /* QuickView */3 ? null : React.createElement(QuickViewOverlay_Lazy$Showside.make, {});
    return React.createElement(BaseWithTheme$Showside.make, {
      initiator: "bottombar",
      className: CSS$Showside.prefix("smartnav-bottombar"),
      portal: true,
      children: React.createElement(EntrypointCallbacks$Showside.make, tmp, React.createElement(EscapeKeyController$Showside.make, {
        embedType: embedType
      }), React.createElement(DrawerState$Showside.Provider.make, {
        value: drawerState,
        children: null
      }, React.createElement(ConditionalRender$Showside.When.make, {
        condition: scrollLocked || drawerState === /* Opening */1 || drawerState === /* Open */2 || isQuickView,
        children: React.createElement(PausePageScrolling$Showside.make, {})
      }), React.createElement(GridDensityZoomProvider$Showside.make, {
        children: React.createElement(ListPageLayoutController$Showside.make, {
          onChange: function (param) {
            Curry._1(anchorHookResult.setOffset, param.anchorsOffset);
          },
          scrollableContainerRef: scrollableContainerRef,
          autoHidePrimaryNavbar: isMobile,
          children: renderMainWrapper(React.createElement("div", {
            ref: ReactDOMUtils$Showside.Ref.domRef(drawerContentRef),
            className: CSS$Showside.prefix("flex flex-col-reverse flex-grow")
          }, tmp$1))
        })
      }), tmp$3, React.createElement(ConditionalRender$Showside.When.make, {
        condition: config.settings.cart,
        children: React.createElement(MiniCartDrawer_Lazy$Showside.make, {})
      })))
    });
  };
  var pictureInPicture = config.settings.quickviewPictureInPicture;
  return React.createElement(ConditionalRender$Showside.When.make, {
    condition: pictureInPicture,
    children: React.createElement(PictureInPictureContext$Showside.make, {
      children: null
    }, renderContent(undefined), React.createElement(PictureInPicture2_Lazy$Showside.make, {})),
    fallback: renderContent(undefined)
  });
}
BottombarApp.displayName = "BottombarApp";
var make = React.memo(BottombarApp);
var $$default = make;
export { make, $$default, $$default as default };
/* make Not a pure module */